import React from 'react'
import { Backdrop, CircularProgress, makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff'
	}
}))
const BackdropLoader = ({ loading }) => {
	const classes = useStyles()
	return (
		loading && (
			<Backdrop className={classes.backdrop} open={loading}>
				<CircularProgress color="inherit" />
			</Backdrop>
		)
	)
}
export default BackdropLoader
BackdropLoader.propTypes = {
	loading: PropTypes.bool.isRequired
}
